// ES Analytics API Response Models

export class EmailCoverageResponse {
  current_coverage_percentage: number = 0;
  previous_coverage_percentage: number = 0;
  coverage_percentage_change: number = 0;
  last_updated: string = '';
}

export class EmailFunnelResponse {
  total_email_volume: number = 0;
  total_email_volume_previous: number = 0;
  total_email_volume_pct_change: number | null = null;
  total_threats_detected: number = 0;
  total_threats_detected_previous: number = 0;
  total_threats_detected_pct_change: number | null = null;
  total_threats_blocked: number = 0;
  total_threats_blocked_previous: number = 0;
  total_threats_blocked_pct_change: number | null = null;
  total_breakthrough_incidents: number = 0;
  total_breakthrough_incidents_previous: number = 0;
  total_breakthrough_incidents_pct_change: number | null = null;
}

export class EmailThreatsByTypeResponse {
  total_security_events: number = 0;
  security_events: Array<{ value: string; count: number }> = [];
}

export class TopAttackedUsersResponse {
  topAttackedUsers: Array<{ name: string; title: string; department: string; attackCount: number }> = [];
}

export class GeographicThreatsResponse {
  geographicThreats: Array<{ name: string; count: number }> = [];
}

export class EventsPendingReviewResponse {
  total_events_pending_review: number = 0;
  total_events_pending_review_previous: number = 0;
  total_events_pending_review_change: number = 0;
  last_updated: string = '';
}

export class ConfigStatusResponse {
  config_id: number = 0;
  config_status: string = '';
  last_updated: string = '';
}

export class EmailAverageCoverageResponse {
  average_coverage_percentage: number = 0;
  average_coverage_percentage_previous: number = 0;
  average_coverage_percentage_change: number = 0;
}

export class ThreatCampaignResponse {
  total_suspicious_senders: number = 0;
  top_suspicious_sender: string | null = null;
  top_sender_volume: number = 0;
  indicators: string[] = [];
  top_sender_velocity?: number = 0;
  top_sender_role_spread?: number = 0;
  top_suspicious_senders: Array<{ sender: string; volume: number }> = [];
  last_updated: string | null = null;
}

export class CheckpointProtectionResponse {
  chartData: Array<{ name: string; value: number }> = [];
}

export class ShadowItTrendsResponse {
  categoryBreakdown: Array<{ category: string; percentage: number }> = [];
  trendPercentageChange: number | null = null;
  chartData: {
    categories: string[];
    series: Array<{ name: string; data: number[] }>;
  } = {
    categories: [],
    series: [],
  };
}

export class BreakthroughIncidentsAnalysisResponse {
  total_breakthrough_incidents: number = 0;
  percentage_change: number = 0;
  sender_domain_patterns: Array<{
    type: string;
    count: number;
    percentage: number;
  }> = [];
  subject_line_patterns: Array<{
    type: string;
    count: number;
    percentage: number;
  }> = [];
  attachment_type_patterns: Array<{
    type: string;
    count: number;
    percentage: number;
  }> = [];
  recommended_actions: Array<{
    priority: string;
    description: string;
    estimated_impact: string;
    implementation_effort: string;
  }> = [];
}

export class PendingReviewItem {
  id: number = 0;
  eventName: string = '';
  severity: string = '';
  dateTime: string = '';
  threatType: string = '';
  user: string = '';
  mailbox: string = '';
  details: string = '';
  status: string = '';
  available_actions: string[] = [];
}

export class PendingReviewItemsResponse {
  items: PendingReviewItem[] = [];
  total_count: number = 0;
  last_updated: string = '';
}

export interface ConfigurationItem {
  id: string;
  name: string;
  goldStandardSetting: string;
  currentStatus: 'compliant' | 'non_compliant';
  canAcceptDeviation: boolean;
  isPolicySpecific: boolean;
  isDeviationAccepted: boolean;
  exceptionNote?: string;
  lastUpdated: string;
}

export interface ConfigurationStatusDetailResponse {
  organizationId: number;
  overallStatus: string;
  compliancePercentage: number;
  configurationItems: ConfigurationItem[];
  lastUpdated: string;
}
